import React, { useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { MaintenanceRecord } from '../../../../types/api';
import { HistoricalMaintenanceCard } from './components/HistoricalMaintenanceCard';
import { ViewHistoricalMaintenanceDialog } from './components/ViewHistoricalMaintenanceDialog';

interface HistoricalMaintenanceListViewProps {
  maintenanceRecords: MaintenanceRecord[];
  loading: boolean;
  error?: string | null;
  droneSerial?: string;
  onRefresh?: () => void;
}

export const HistoricalMaintenanceListView: React.FC<HistoricalMaintenanceListViewProps> = ({
  maintenanceRecords,
  loading,
  error,
  droneSerial,
}) => {
  const [selectedRecord, setSelectedRecord] = useState<MaintenanceRecord | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleCardClick = (record: MaintenanceRecord) => {
    setSelectedRecord(record);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedRecord(null);
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
        }}
      >
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          color: '#d32f2f',
        }}
      >
        <Typography variant="body2">{error}</Typography>
      </Box>
    );
  }

  if (maintenanceRecords.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          color: '#999',
        }}
      >
        <Typography variant="body2">
          {droneSerial
            ? 'No maintenance history available'
            : 'Select a drone to view maintenance history'}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box>
        {maintenanceRecords.map((item) => (
          <HistoricalMaintenanceCard key={item.id} record={item} onClick={handleCardClick} />
        ))}
      </Box>

      <ViewHistoricalMaintenanceDialog
        open={dialogOpen}
        record={selectedRecord}
        onClose={handleCloseDialog}
      />
    </>
  );
};
